//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

export const getAddToGalleriesInitialSelectedItems = createSelector(
  (state: ICuralateStore) =>
    state.galleries.addToGalleriesModal.initiallySelectedItems,
  (initiallySelectedItems) => initiallySelectedItems,
);
